const OrderTypes = {
    "live-chat": "live-chat",
    "video-call": "video-call",
    "voice-call": "voice-call"
};
var order = Object.freeze(OrderTypes);

export { order as default };
//# sourceMappingURL=order.js.map
